import React, { type CSSProperties } from 'react';

import { ETonalButtonClassNames } from '../enums/ETagButtonColors';

interface tagButtonProps {
  children: string | JSX.Element;
  color?: ETonalButtonClassNames;
  size?: 'inherit' | 'xs';
  marginTopInRem?: number;
  className?: string;
  onClick?: (ev: React.MouseEvent<HTMLStyleElement>) => void;
  style?: CSSProperties;
}

/**
 * TODO: Rename to CTagButton
 * @param props
 * @constructor
 */
export default function TagButton(props: tagButtonProps) {
  const classNames = ['uppercase tracking-wider whitespace-nowrap'];
  classNames.push(props.color ?? ETonalButtonClassNames.DEFAULT);

  switch (props.size) {
    case 'xs':
    default:
      classNames.push('text-xs px-2 py-0.5 rounded-md');
      break;
  }

  if (props.className) {
    classNames.push(props.className);
  }

  return (
    <strong
      className={classNames.join(' ')}
      style={{ marginTop: `${props.marginTopInRem}rem`, ...props.style }}
      onClick={props.onClick}
    >
      {props.children}
    </strong>
  );
}
